/* eslint-disable max-lines */
/* eslint-disable max-len */

const methods = {
  fetchData() {
    this.uuid_issue = this.$route.query.id || this.id || this.$route.params.uuid;
    this.loadIssue(this.uuid_issue);
  },

  async loadIssue(uuid) {
    if (this.editable) {
      try {
        const resIssue = await this.$issuesService.getIssuesByUUIId(uuid);
        const resCategories = await this.$issuesService.categories();
        const { categories } = resCategories.data;
        this.categories = categories;
        this.formatFormIssuWithBackData(resIssue.data.issue);
        this.loading = false;
      } catch (error) {
        this.$toast.error('Error', error);
        this.loading = false;
      }
    } else {
      Promise.all([
        this.$issuesService.getIssuesByUUIId(uuid, {}),
        this.$issuesService.categories({}),
        this.$issuesService.files(uuid, {})
      ])
        .then(res => {
          this.formValues.issue = res[0].data.issue;
          this.expires_on = this.$moment(this.formValues.issue.expires_on).format('YYYY-MM-DD HH:mm:ss');
          this.categories = res[1].data.categories;
          this.files = res[2].data.documents;
          this.loading = false;
        })
        .then(() => this.getComments());
    }
  },

  formatFormIssuWithBackData(data) {
    this.formValues = {
      subject: data.subject,
      description: data.description,
      expires_on: this.$moment(data.expires_on).format('YYYY-MM-DD HH:mm:ss'),
      category: data.category
    };
    this.formValues.blocking = {
      name: data.blocking ? 'Bloqueante' : 'No bloqueante',
      value: data.blocking
    };
    // Objeto: account/interveners/operation
    if (data.accounts) {
      const account = data.accounts[0];
      this.formValues.object = {
        uuid: account.uuid,
        name: account.id_object,
        link: `${process.env.VUE_APP_API_HOST}/accounts-api/accounts/${account.uuid}`,
        type: 'account'
      };
    }
    if (data.interveners) {
      const intervener = data.interveners[0];
      this.formValues.object = {
        uuid: intervener.uuid,
        name: `${intervener.name} ${intervener.lastname_1}`,
        link: `${process.env.VUE_APP_API_HOST}/accounts-api/accounts/${intervener.uuid}`,
        type: 'intervener'
      };
    }
    if (data.operations) {
      const operation = data.operations[0];
      this.formValues.object = {
        uuid: operation.uuid,
        name: `${operation.id_object}`,
        link: `${process.env.VUE_APP_API_HOST}/accounts-api/operations/${operation.uuid}`,
        type: 'operation'
      };
    }
    // Responsable: user/group
    if (data.user_assigned) {
      const user = data.user_assigned;
      this.formValues.asignee = {
        uuid: user.uuid,
        name: `${user.given_name} ${user.family_name_1 || ''} ${user.family_name_2 || ''}`,
        link: `${process.env.VUE_APP_API_HOST}/users-api/users/${user.uuid}`,
        type: 'user'
      };
    }
    if (data.group_assigned) {
      const group = data.group_assigned;
      this.formValues.asignee = {
        uuid: group.uuid,
        name: group.key_name,
        link: `${process.env.VUE_APP_API_HOST}/users-api/groups/${group.uuid}`,
        type: 'group'
      };
    }
  },

  restoreValues() {
    this.formValues = {
      _links: {},
      asignee: null,
      blocking: null,
      category: null,
      description: '',
      expires_on: null,
      object: null,
      subject: ''
    };
    this.saving = false;
    this.savingTitle = 'Guardar cambios';
  },

  onSearchObjectChange(query) {
    if (!query) {
      return;
    }

    clearTimeout(this.timeOutSearch);
    this.timeOutSearch = setTimeout(() => {
      const cfg = {
        params: {
          // '$expand': 'group,permission_set'
        }
      };
      const q = query.split(' ');
      Promise.all([
        this.$accountsService.getSearch(JSON.stringify(q), cfg),
        this.$intervenersService.getSearch(JSON.stringify(q), cfg),
        this.$operationsService.getSearch(JSON.stringify(q), cfg)
      ]).then(res => {
        const accounts = res[0].data.accounts.map(x => {
          return {
            uuid: x.uuid,
            name: x.id_object,
            link: x._links._self.href,
            type: 'account'
          };
        });
        const interveners = res[1].data.interveners.map(x => {
          const lastname2 = x.lastname_2 ? ` ${x.lastname_2}` : '';
          const document = x.document_id ? ` - ${x.document_id}` : '';
          return {
            uuid: x.uuid,
            name: `${x.lastname_1}${lastname2}, ${x.name}${document}`,
            link: x._links._self.href,
            type: 'intervener'
          };
        });
        const operations = res[2].data.operations.map(x => {
          return {
            uuid: x.uuid,
            name: x.id_object,
            link: x._links._self.href,
            type: 'operation'
          };
        });
        this.objectType = [
          {
            language: 'Accounts',
            libs: accounts
          },
          {
            language: 'Interveners',
            libs: interveners
          },
          {
            language: 'Operations',
            libs: operations
          }
        ];
      });
    }, this.timeOutSearchTime);
  },
  onSearchChange(query) {
    const cfg = {
      params: {
        // '$expand': 'group,permission_set'
      }
    };
    const q = query.split(' ');

    Promise.all([
      this.$usersService.getSearch(JSON.stringify(q), cfg),
      this.$groupsService.getSearch(JSON.stringify(q), cfg)
    ]).then(res => {
      const users = res[0].data.users.map(x => {
        return {
          uuid: x.uuid,
          name: `${x.given_name} ${x.family_name_1} ${x.family_name_2 ? x.family_name_2 : ''}`,
          link: x._links._self.href,
          type: 'user'
        };
      });
      const groups = res[1].data.groups.map(x => {
        return {
          uuid: x.uuid,
          name: `${x.key_name}`,
          link: x._links._self.href,
          type: 'group'
        };
      });
      this.asigneeType = [
        {
          language: 'Users',
          libs: users
        },
        {
          language: 'Groups',
          libs: groups
        }
      ];
    });
  },

  setExpirationDate(val) {
    if (val) {
      val = val.replace(/--/g, '00');
    }
    this.formValues.expires_on = val;
  },

  async onSubmit(e) {
    this.$v.$touch();
    this.submitted = true;
    if (!this.validForm()) {
      return;
    }
    e.preventDefault();
    if (this.$v.$invalid || !this.validForm) {
      window.scrollTo(0, 0);
    } else {
      this.saving = true;
      this.savingTitle = 'Guardando...';

      const payload = this.formatIssueForm();
      if (this.editable && !this.$route.name.includes('issues_add')) {
        // Se añade el UUID del caso para obtenerlo en el servicio
        payload.uuid = this.uuid_issue;
        try {
          const res = await this.$issuesService.update(payload);
          this.restoreValues();
          this.$store.dispatch('formStore/deleteForm', this.$route.name);
          this.updateItemMenu(res);
        } catch (error) {
          this.restoreValues();
          this.$toast.error(`Error al guardar caso`, error);
        }
      } else {
        // Creación de nueva incidencia
        try {
          const res = await this.$issuesService.create(payload);
          const { issue } = res.data;
          // Actualizar pestaña
          this.$store.dispatch('formStore/deleteForm', this.$route.name);
          this.closeActiveTab('issues');
          const item = {
            active: true,
            name: issue.subject,
            route: {
              name: 'issues_uuid',
              params: {
                uuid: issue.uuid
              },
              force: true
            }
          };
          this.setMenuTab(item);
          this.$toast.success(`OK`, `Incidencia creada con éxito`);
        } catch (error) {
          this.restoreValues();
          this.$toast.error(`Error creación caso`, error);
        }
      }
    }
  },

  formatIssueForm() {
    const data = this.formValues;
    const linksToPayload = {};
    // Tipo de objeto: account/intervener
    switch (data.object.type) {
      case 'account':
        linksToPayload.accounts = [data.object.link];
        break;
      case 'intervener':
        linksToPayload.interveners = [data.object.link];
        break;
      case 'operation':
        linksToPayload.operations = [data.object.link];
        break;
      default:
        break;
    }
    // Responsable asignado: user/group
    switch (data.asignee.type) {
      case 'user':
        linksToPayload.user_assigned = data.asignee.link;
        break;
      case 'group':
        linksToPayload.group_assigned = data.asignee.link;
        break;
      default:
        break;
    }
    // Añadimos la categoría
    linksToPayload.category = `htts://xxx/${data.category.key_name}`;
    const payload = {
      blocking: data.blocking.value || false,
      description: data.description,
      expires_on: data.expires_on,
      status: 'OPEN',
      subject: data.subject,
      _links: {
        ...linksToPayload,
        document: this.$route.query.document ? this.$route.query.document : undefined
      }
    };
    return payload;
  },

  hasError(field) {
    let error;
    const fieldModel = this.$v.formValues[field];
    switch (field) {
      case 'subject':
      case 'object':
      case 'description':
        if (fieldModel.minLength && !fieldModel.minLength) {
          error = `${this.$t(`headers.${field}`)} debe tener un mínimo de ${
            fieldModel.$params.minLength.min
          } carácteres.`;
        } else if (fieldModel.maxLength && !fieldModel.maxLength) {
          error = `${this.$t(`headers.${field}`)} debe tener un máximo de ${
            fieldModel.$params.maxLength.max
          } carácteres.`;
        } else if (fieldModel.required && fieldModel.$error) {
          error = `${this.$t(`headers.${field}`)} no es válido.`;
        } else if (this.submitted && !fieldModel.required) {
          error = `${this.$t(`headers.${field}`)} es requerido.`;
        }
        break;

      default:
        break;
    }

    return error;
  },
  handleCancel() {
    this.$store.dispatch('formStore/deleteForm', this.$route.name);
    if (this.uuid_issue) {
      this.$router.push({ name: 'issues_uuid', params: { uuid: this.uuid_issue } });
    } else {
      const issuesRelation = ['interveners_uuid', 'accounts_uuid', 'operations_uuid'];
      const items = this.$store.getters['yuriMenuStore/items'];
      const lastIssues = items.find(x => x.route.name === 'issues');
      const indexActiveMenu = this.$store.getters['yuriMenuStore/activeItem'];
      const subitem = items.find(x => {
        const children = x.children && x.children.length > 0 ? x.children : null;
        if (issuesRelation.includes(x.route.name) && children && x.route && x.route.params) {
          return this.$route.query ? x.route.params.uuid === this.$route.query.id : false;
        }
        return false;
      });

      if (subitem) {
        const subindex = subitem.children
          .map(elem => {
            return elem.route.query ? elem.route.query.id : null;
          })
          .indexOf(this.$route.query.id);
        this.$store
          .dispatch('yuriMenuStore/removeSubItem', subindex)
          .then(() => this.$store.dispatch('yuriMenuStore/disableItemsSubMenu'))
          .then(() => {
            this.$router.push(subitem.route);
          });
      } else if (lastIssues) {
        this.$store.dispatch('yuriMenuStore/removeItem', indexActiveMenu).then(() => {
          this.$store.dispatch('yuriMenuStore/setActiveItem', lastIssues).then(() => {
            this.$router.replace(lastIssues.route);
          });
        });
      } else {
        this.closeActiveTab('dashboard');
      }
    }
  },

  generateIssue() {
    this.$console.warn('generateIssue');
    this.$console.table(this.$route.query);
    const { type } = this.$route.query;

    // Pongo el título de la incidencia, es común para todos
    // Le he tenido que poner un setTimeout porque en algunos casos no lo cogía bien
    setTimeout(() => {
      this.formValues.subject = this.$route.query.subject;
    }, 500);
    switch (type) {
      case 'INTERVENER':
        this.generateIssueIntervener(this.$route.query);
        break;
      case 'DOCUMENTATION':
        this.generateIssueDocumentation(this.$route.query);
        break;
      case 'ACCOUNT':
        this.generateIssueAccount(this.$route.query);
        break;
      case 'OPERATION':
        this.generateIssueOperation(this.$route.query);
        break;
      default:
        break;
    }
  },

  async generateIssueIntervener(payload) {
    this.loading = true;
    try {
      const res = await this.$intervenersService.getIntervenersByUUIId(payload.id);
      const { intervener } = res.data;
      const { personal_data: personalData } = intervener;
      this.formValues.object = {
        uuid: payload.id,
        name: `${personalData.lastname_1}, ${personalData.name}  - ${personalData.document_id}`,
        link: `${process.env.VUE_APP_API_HOST}/interveners-api/interveners/${payload.id}`,
        type: 'intervener'
      };
    } catch (error) {
      this.$toast.error(`Error`, `Error en generateIssueIntervener: ${error}`);
      this.loading = false;
    }
  },

  // TODO: revisar esta función, no genera bien la incidencia
  async generateIssueDocumentation(payload) {
    this.loading = true;
    try {
      this.formValues.category = { key_name: 'DOCUMENTATION' };
      if (payload.typeObject === 'intervener') {
        const resInternver = await this.$intervenersService.getIntervenersByUUIId(payload.id);
        const { intervener } = resInternver.data;
        const { personal_data: personalData } = intervener;
        this.formValues.object = {
          uuid: payload.id,
          name: `${personalData.lastname_1}, ${personalData.name}  - ${personalData.document_id}`,
          link: `${process.env.VUE_APP_API_HOST}/interveners-api/interveners/${payload.id}`,
          type: 'intervener'
        };
        setTimeout(() => {
          this.onSelectObject(intervener);
        }, 200);
      } else if (payload.typeObject === 'account') {
        const resAccount = await this.$accountsService.getAccountsByUUId(payload.id);
        const { account, _self: links } = resAccount.data;
        this.formValues.object = {
          uuid: account.uuid,
          name: account.id_object,
          link: links.href,
          type: 'account'
        };
      } else {
        const resOperation = await this.$operationsService.getOperationsByUUId(payload.id);
        const { operation, _self: links } = resOperation.data;
        this.formValues.object = {
          uuid: operation.operation_id,
          name: operation.id_object,
          link: links.href,
          type: 'operation'
        };
      }
      this.loading = false;
    } catch (error) {
      this.$toast.error(`Error`, `Error en generateIssueDocumentation: ${error}`);
      this.loading = false;
    }
  },

  async generateIssueAccount(payload) {
    this.loading = true;
    try {
      const resAccount = await this.$accountsService.getAccountsByUUId(payload.id);
      const { account, _self: links } = resAccount.data;
      this.formValues.object = {
        uuid: account.uuid,
        name: account.id_object,
        link: links.href,
        type: 'account'
      };
      this.loading = false;
    } catch (error) {
      this.$toast.error(`Error`, `Error en generateIssueAccount: ${error}`);
      this.loading = false;
    }
  },

  async generateIssueOperation(payload) {
    this.loading = true;
    try {
      const resOperation = await this.$operationsService.getOperationsByUUId(payload.id);
      const { operation, _self: links } = resOperation.data;
      this.formValues.object = {
        uuid: operation.uuid,
        name: operation.id_object,
        link: links.href,
        type: 'operation'
      };
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.$toast.error(`Error`, `Error en generateIssueOperation: ${error}`);
    }
  },

  async updateItemMenu(res) {
    if (JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).user.uuid === this.uuid_issue) {
      this.logout();
      this.$toast.success(`Success`, `${res.result.info}`);
      this.$router.replace(`/login`);
    } else {
      const tabTitle = res.data.issue.subject;
      let done;

      if (this.$route.name === 'issues_uuid_view') {
        done = await this.$store.dispatch('yuriMenuStore/updateSubItemName', tabTitle);
      } else {
        done = await this.$store.dispatch('yuriMenuStore/updateItemName', tabTitle);
      }

      if (done) {
        this.$toast.success(`${res.result.http_code}`, `${res.result.info}`);
        this.$router.go(-1);
      }
      // });
    }
  },
  clearField(field) {
    this.formValues[field] = undefined;
    this.keyUpdate++;
    this.validForm();
  },

  validForm() {
    let valid = true;
    if (!this.formValues.asignee) {
      valid = false;
    }
    if (!this.formValues.object) {
      valid = false;
    }
    return this.$v.formValues.$invalid || !valid ? false : true;
  },
  categorySelected(v) {
    const { group } = v;
    this.formValues.asignee = {
      uuid: group.uuid,
      name: group.key_name,
      link: `${process.env.VUE_APP_API_HOST}/users-api/groups/${group.uuid}`,
      type: 'group'
    };
  }
};

export default methods;
